


































































import { Component, Prop, Vue } from "vue-property-decorator";
import { ClientSetupFunctions, ClientSetupMaster } from "@/data/models/ClientSetup";
import { MIRA_MODES, toMiraMode } from "@/data/models/MiraMode";
import { CHAT_MODE_VALUES, ChatMode, chatFlagsFromMode, chatModeFromFlags } from "@/utils/ChatMode";
import { EMPTY_VALUE } from "@/utils/ClientAdministrationDetail";
import { ClientSetupDraft, applyFunctionDependencies, followsMaster } from "@/utils/ClientSetupDraft";
import { FUNCTION_SWITCH_LABEL_KEYS, SummaryLine, assistModeKey, enabledFunctionsText } from "@/utils/ClientSetupSummary";

/** ASSIST as Systemkonfiguration offers it: off, or on with its activation scope. */
const ASSIST_MODES = ["ALL_DRYINGS", "ACTIVE_AND_NEW_ONLY", "OFF"];

@Component
export default class SetupFunctionsStep extends Vue {
  @Prop({ required: true }) draft!: ClientSetupDraft;
  @Prop({ default: null }) master!: ClientSetupMaster | null;

  switches = FUNCTION_SWITCH_LABEL_KEYS;

  get member(): boolean {
    return followsMaster(this.draft);
  }

  get masterName(): string {
    return this.master?.name ?? EMPTY_VALUE;
  }

  get masterLines(): SummaryLine[] {
    const functions = this.master?.functions;
    const t = (key: string) => this.$t(key).toString();
    if (!functions) {
      return [{ label: t("admin.clients.setup.steps.functions"), value: t("admin.clients.setup.followsMaster") }];
    }
    return [
      { label: t("admin.clients.setup.functions.enabled"), value: enabledFunctionsText(functions, t) },
      {
        label: t("settings.system.chat.title"),
        value: t(`settings.system.chat.mode.${chatModeFromFlags(functions.enablePersonalChat === true, functions.enableProjectChat === true)}`),
      },
      { label: t("settings.aiPredictions.title"), value: t(`settings.aiPredictions.mode.${assistModeKey(functions)}`) },
      { label: t("settings.system.mira.title"), value: t(`settings.system.mira.mode.${toMiraMode(functions.miraMode)}`) },
    ];
  }

  get miraItems() {
    return MIRA_MODES.map((value) => ({ value, label: this.$t(`settings.system.mira.mode.${value}`).toString() }));
  }

  get chatItems() {
    return CHAT_MODE_VALUES.map((value) => ({ value, label: this.$t(`settings.system.chat.mode.${value}`).toString() }));
  }

  get chatMode(): ChatMode {
    return chatModeFromFlags(this.draft.functions.enablePersonalChat, this.draft.functions.enableProjectChat);
  }

  set chatMode(mode: ChatMode) {
    Object.assign(this.draft.functions, chatFlagsFromMode(mode));
  }

  get assistItems() {
    return ASSIST_MODES.map((value) => ({ value, label: this.$t(`settings.aiPredictions.mode.${value}`).toString() }));
  }

  get assistMode(): string {
    return assistModeKey(this.draft.functions);
  }

  set assistMode(mode: string) {
    this.draft.functions.enableAiPredictions = mode !== "OFF";
    if (mode !== "OFF") {
      this.draft.functions.renoActivationScope = mode as ClientSetupFunctions["renoActivationScope"];
    }
  }

  isBlocked(field: keyof ClientSetupFunctions): boolean {
    return (field === "enableTracking" && !this.draft.functions.enableGeoEncoding) ||
      (field === "enableDeviceManagementTile" && !this.draft.functions.enableAllDevicesManagement);
  }

  onSwitchChanged() {
    applyFunctionDependencies(this.draft.functions);
  }
}
